module.exports = "/_next/static/images/77e86ce443f6a539b292414ff2bcb12e-left-side-desktop.jpg";